<template>
  <v-app-bar color="white" elevation=0>
      <v-btn :href="frontendUrl">
         <v-app-bar-title>
            <img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" />
         </v-app-bar-title>
      </v-btn>
   </v-app-bar>
   <v-app>
      <v-main>
         <v-container class="fill-height">
            <v-row align="center" justify="center" class="fill-height">
               <v-col cols="12" sm="8" md="6">
                  <v-card v-if="!emailSent" class="pa-4">
                     <v-card-title class="text-center pb-6">
                        <h3 style="font-family: 'Poppins', sans-serif;">Reset your password</h3>
                     </v-card-title>
                     <v-card-text>
                        <v-form v-model="isFormValid">
                           <v-text-field
                              v-model="resetEmail"
                              color="primary"
                              label="Email"
                              variant="outlined"
                              :rules="emailRules"
                              prepend-inner-icon="mdi-email-outline"
                           ></v-text-field>
                           <p class="pl-2" style="color: red">{{ resetError }}</p>
                        </v-form>
                     </v-card-text>
                     <v-card-actions class="pa-6">
                        <v-row>
                           <span>
                              <v-btn :disabled="!isFormValid" @click="resetPassword" color="primary">Send Email with Reset Link</v-btn>
                           </span>
                        </v-row>
                     </v-card-actions>
                     <v-row justify="center" align="center" class="py-6">
                        <a href="/login" class="forgot-password">Back to Login</a>
                     </v-row>
                  </v-card>
                  <v-card v-else>
                     <v-card-title class="text-center pb-6">
                        <h3 style="font-family: 'Poppins', sans-serif;">Reset link sent</h3>
                     </v-card-title>
                     <v-card-text class="text-center">
                        <span class="forgot-password">
                           We have sent an email to {{ resetEmail }} with a link to reset your password. 
                        </span>
                     </v-card-text>
                  </v-card>
               </v-col>
            </v-row>
       </v-container>
     </v-main>
   </v-app>
 </template>
 
 <script>
 import { mapActions, mapGetters } from "vuex";
 import router from "@/router";
 import inletsLogo from "@/assets/images/inlets-logo-color.svg";

 export default {
   name: 'Login',
   computed: {
        ...mapGetters(["getAuthToken", "getUserEmail", "getUserID", "isLoggedIn"]),
        resetError() {
            return this.$store.state.auth.reset_error
        },
        frontendUrl() {
            return process.env.VUE_APP_FRONTEND_URL
        },
    },
   data() {
        return {
            inletsLogo,
            isFormValid: false,
            resetEmail: "",
            emailRules: [
               v => !!v || "Please enter a valid email",
               v => /.+@.+\..+/.test(v) || "Invalid email format",
            ],
            emailSent: false,
        };
    },
   methods: {
      ...mapActions(["sendResetEmail"]),
      async resetPassword(event) {
         event.preventDefault();
         let data = {
               email: this.resetEmail,
         };
         await this.sendResetEmail(data);
         this.emailSent = true;
      },
      toLogin() {
         router.push({ name: 'Login' });
      }
   }
 }
 </script>
 <style scoped>
 .forgot-password {
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
    color: #65647C;
    text-decoration: none;
 }
 </style>
 